export const ROUTING_PARAMS_CHANGED = Symbol('ROUTING_PARAMS_CHANGED')
export const SET_SIDEBAR_VISIBILITY = Symbol('SET_SIDEBAR_VISIBILITY')
export const TOGGLE_DROPDOWN = Symbol('TOGGLE_DROPDOWN')
export const OPEN_DROPDOWN = Symbol('OPEN_DROPDOWN')
export const CLOSE_DROPDOWN = Symbol('CLOSE_DROPDOWN')



// WEBPACK FOOTER //
// ./app/editor/actions/action-types.js